export const umAuthConfig = {
  uiUrl: process.env.REACT_APP_UM_uiUrl,
  postLogOutUri: process.env.REACT_APP_UM_postLogOutUri,

  /**
      NOTE: UNCOMMENT & UPDATE BELOW KEYS FOR LOWER ENVIRONMENTS of UM (DEV & QA).
            REACH OUT TO UM TEAM FOR RESPECTIVE LATEST VALUES.
      NOTE: ALL COLLABORATION ENVs (DEV, QA & Prod) are hosted in UM PROD. HENCE, BELOW KEYS ARE NOT REQUIRED. 

      apiUrl: 'https://qaapi.carrierappshub.com/'
      postLogoutRedirectUri: 'http://localhost:3000,
      userPoolId: 'us-east-2_rjmskKvmB',
      identityPoolId: 'us-east-2:d134dd1a-560b-46cf-a917-c9aae0684eea',
      clientId: '4pf6qvsk8b2rd9n1raj22ka18b',
      domain: 'carrierum.auth.us-east-2.amazoncognito.com',
  */
};
